import 'es6-promise/auto'
import babelPolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import ViewerApp from './ViewerApp.vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-select/dist/vue-select.css';
import VueCurrencyFilter from 'vue-currency-filter'
import { app } from "./application.js"
import { store } from './.old/store/store.js'
import { router } from "./routes.js"
import { i18n } from "./i18n.js"
import VueScrollTo from 'vue-scrollto';
import vSelect from 'vue-select'

import VueGtm from 'vue-gtm';
import VueAnalytics from 'vue-analytics'
import VueLazyload from 'vue-lazyload';


Vue.use(VueLazyload);
Vue.use(VueCurrencyFilter, {});
Vue.use(VueRouter);
Vue.use(BootstrapVue);
// Vue.use(VueScrollTo, {
//     offset: - window.innerHeight / 2,
// });
Vue.component('v-select', vSelect);

// Visibility
Vue.directive('visible', function (el, binding) {
    el.style.visibility = !!binding.value ? 'visible' : 'hidden';
});

// Google Analytics
// Vue.use(VueAnalytics, {id: 'UA-1319458-4'});
// Vue.use(VueGtm, {
//     id: 'GTM-NRGHSDN', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
//     queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
//         //   gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
//         //   gtm_preview:'env-4',
//         //   gtm_cookies_win:'x'
//     },
//     enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
//     debug: true, // Whether or not display console logs debugs (optional)
//     loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
//     vueRouter: router, // Pass the router instance to automatically sync with router (optional)
//     ignoredViews: [

//     ] // If router, you can exclude some routes name (case insensitive) (optional)
// });


// Settings
var configElement = document.getElementById('unex_configurator_settings');
var config = {};

if (configElement) {
    config = JSON.parse(configElement.innerHTML);
    //console.log('config: ', config);
}

// FireBase
import * as firebase from 'firebase/app'
import 'firebase/analytics'

//firebaseConfig cas general
var firebaseConfig = {
    apiKey: "AIzaSyDjDmsdMjeItN5kHLprJUEEXzQUsXbzUr8",
    authDomain: "unex-configurators-dev.firebaseapp.com",
    databaseURL: "https://unex-configurators-dev.firebaseio.com",
    projectId: "unex-configurators-dev",
    storageBucket: "unex-configurators-dev.appspot.com",
    messagingSenderId: "900719641246",
    appId: "1:900719641246:web:52bd014b3b17f18f21b18f",
    measurementId: "G-6Y2HQHKDYD"
};

//firebaseConfig cas produccio
if (!config.env || config.env == 'prod') {
    //config.analytics && config.analytics == 'prod') {

    firebaseConfig = {
        apiKey: "AIzaSyAkZZCK5hdOw-C9IXncbAPH1eaaHVEYzPg",
        authDomain: "unex-configurators.firebaseapp.com",
        databaseURL: "https://unex-configurators.firebaseio.com",
        projectId: "unex-configurators",
        storageBucket: "unex-configurators.appspot.com",
        messagingSenderId: "908610690058",
        appId: "1:908610690058:web:d0eb62add7a0eeca0b13f3",
        measurementId: "G-VQPSYYDDYB"
    };

}

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

app.analytics = firebase.analytics();

// Set apiURL
app.API.setEnvironment(
    config.env,
    config.apiUrl
);
app.env = config.env

if( config.webVersion ){
    app.webVersion = config.webVersion;
}

// app.API.setLanguageMarket(
//     config.language,
//     config.market
// );

app.router = router;

// Auth config
if (config.auth === false) {
    app.auth.enabled = false;
} else {
    // Ensure we have a object in case authentication comes after configurator
    // TODO: @remove Teoricament ja no cal...
    // Unex.Authentication.checkForLoggedUserStorage();
}

$(document).ready(function () {
    app.init();

    // Init language
    app.initLanguageMarket(config);

    // Init wholeSalers
    app.WholeSaler.config(config);

    // Full Configurator App
    if (document.getElementById('unex_configurator_app')) {
        let vueApp = new Vue({
            router,
            i18n,
            store,
            el: '#unex_configurator_app',
            beforeMount: function () {
            },
            render: h => h(App)
        })
        app.AppComponent = vueApp;
        window.App = vueApp;
    }

    window.Unex.Configurator = app;

    // Vue.config.errorHandler = (err, vm, info) => {
    //     // err: error trace
    //     // vm: component in which error occured
    //     // info: Vue specific error information such as lifecycle hooks, events etc.

    //     // TODO: Perform any custom logic or log to server

    //     console.error('------------------------');
    //     console.error('error: ', err.message);
    //     console.error('------------------------');
    //     console.error('found in component: ', vm);
    //     console.error('info: ', info);
    //     console.error('------------------------');

    //     app.trackError(err.message, true);
    //     Unex.error("Error tracked: " + err.message);
    //     Unex.error(err);
    //     Unex.error(vm);
    //     Unex.error(info);
    // };

    var viewerAppElement = document.getElementById('unex_configurator_viewerApp')
    if (viewerAppElement) {
        var configurationId = viewerAppElement.getAttribute('configurationId');
        let viewerApp = new Vue({
            // router,
            i18n,
            // store,
            el: '#unex_configurator_viewerApp',
            props: ['configurationId'],
            beforeMount: function () {
            },
            render: h => h(ViewerApp, { props: {
                configurationId: configurationId,
            } })
        })
        // console.error(viewerApp)
        // viewerApp.methods.setId(configurationId)
        // viewerApp.$data.id = configurationId
        // console.error(viewerApp.$data.id)
    }
});